/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityPostureResponse {
    getFixupPrototypeFunction() { return SecurityPostureResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityPostureResponse>): SecurityPostureResponse {
        let obj = Object.assign(new SecurityPostureResponse(), model);
        SecurityPostureResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityPostureResponse>): SecurityPostureResponse {
        if (!model) return null;
        return SecurityPostureResponse.newInstance(<SecurityPostureResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityPostureResponse) {
        if (!obj) return;

        models.SecurityPostureResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityPostureResponse): boolean {
        Object.setPrototypeOf(obj, SecurityPostureResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
    }

    /**
     * Service wise details of the security findings
     */
    service: any;

    /**
     * Cloud Account wise details of the security findings
     */
    cloud_account: any;

    /**
     * Total count of cloud accounts
     */
    total_count: number;

    /**
     * Total number of page count
     */
    page_count: number;

}
